import dayjs from 'dayjs';

// Hooks
import useUser from '@/hooks/swr/useUser';
import useDateLimits from '@/utils/hooks/datepicker/useDateLimits';

// Types
import type { DatepickerCompetitorsType } from '@/utils/localStorage/datepickerCompetitorsLocalStorage';

// Lib
import {
    CURRENT_MONTH,
    CURRENT_QUARTER,
    CUSTOM,
    LAST_3_MONTHS,
    LAST_7_DAYS,
    LAST_30_DAYS,
    PREVIOUS_MONTH,
    PREVIOUS_WEEK
} from '@/lib/periods';

// Components
import { PeriodPicker, PeriodTabs } from '@/components/composite/PeriodPicker';

type PeriodPickerCompetitorsProps = DatepickerCompetitorsType & {
    onChange: (arg: DatepickerCompetitorsType) => void;
};

export function PeriodPickerCompetitors({ date, period, onChange }: PeriodPickerCompetitorsProps) {
    const { user } = useUser();
    const { getMaxDate } = useDateLimits();
    const maxDate = getMaxDate();
    const minDate = dayjs()
        .utc()
        .tz(user?.settings.timezone)
        .subtract(3, 'month')
        .startOf('day')
        .format();

    return (
        <PeriodPicker
            period={period}
            date={date}
            minDate={minDate}
            maxDate={maxDate}
            onChange={onChange}>
            <PeriodTabs
                availablePeriods={[
                    PREVIOUS_WEEK,
                    LAST_7_DAYS,
                    CURRENT_MONTH,
                    LAST_30_DAYS,
                    PREVIOUS_MONTH,
                    CURRENT_QUARTER,
                    LAST_3_MONTHS,
                    CUSTOM
                ]}
            />
        </PeriodPicker>
    );
}
